import { createFileRoute } from '@tanstack/react-router';
import { FormProvider, useForm } from 'react-hook-form';
import { object, ref, string } from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import TextInput from '@/lib/common/inputs/TextInput';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUpRightFromSquare } from '@fortawesome/free-solid-svg-icons';
import { SignupProps, useAuth } from '@/lib/auth/hooks/useAuth';
import AuthFormStyling from '@/lib/auth/components/AuthFormStyling';
import dayjs from 'dayjs';
import { Button } from '@heroui/react';
import { Link } from '@tanstack/react-router';

const schema = object().shape({
    email: string().required().email().label('Email'),
    password: string().required().label('Password'),
    first_name: string().required().label('First name'),
    last_name: string().required().label('Last name'),
    confirmPassword: string()
        .required('Please retype your password.')
        .oneOf([ref('password')], 'Your passwords do not match.')
        .label('Confirm password'),
});

export const Route = createFileRoute('/auth/sign-up')({
    component: RouteComponent,
});

function RouteComponent() {
    const { signup } = useAuth();
    const f = useForm({
        resolver: yupResolver(schema),
        defaultValues: {
            email: '',
            password: '',
            confirmPassword: '',
        },
        mode: 'onChange',
    });

    const onSubmit = (data: SignupProps | { confirmPassword: string }) => {
        signup(data as SignupProps);
    };

    if (dayjs().toString()) {
        return null;
    }

    return (
        <AuthFormStyling>
            <FormProvider {...f}>
                <form onSubmit={f.handleSubmit(onSubmit)}>
                    <div className='grid  gap-3'>
                        <span className='text-2xl font-bold'>Sign Up</span>
                        <TextInput name='email' label='Email' placeholder='email@example.com' type='text' />
                        <TextInput name='first_name' label='First name' placeholder='John' type='text' />
                        <TextInput name='last_name' label='Last name' placeholder='Doe' type='text' />
                        <TextInput name='password' label='Password' type='password' />
                        <TextInput name='confirmPassword' label='Confirm Password' type='password' />
                        <Button color='primary' type='submit' className='btn-primary'>
                            Sign up
                        </Button>
                        <span className='text-center'>
                            Already have an account?{' '}
                            <Link to='/auth/login' className='text-green-500'>
                                Log in
                                <FontAwesomeIcon icon={faUpRightFromSquare} className='pl-2' />
                            </Link>
                        </span>
                    </div>
                </form>
            </FormProvider>
        </AuthFormStyling>
    );
}
